import { client } from '../../graphql/client';
import { CreateEmployee } from "../../graphql/generated-queries/create-employee-queries";
import { getSelectedTenant } from '../../service/store';

export async function createEmployee(input) {
  try {
    const tenant = getSelectedTenant();
    const tenantId = tenant ? tenant.id : null;
    if (tenantId) {
      input.data.tenant = {
        id: tenantId
      }
    }

    const { data } = await client.mutate({ mutation: CreateEmployee, variables: { input: {...input.data} } });
    return { data: {...data.createEmployee} };
  } catch (err) {
    console.error(err);
  }
}
